
import { EntityConfig } from './types';

export const PAGE_CONFIG: EntityConfig = {
  entityType: 'page',
  tableName: 'workbook_page_research_attachments',
  entityIdColumn: 'page_content_id',
  researchLimit: 2,
  queryKey: ['page-attached-research'],
  displayName: 'Page Research'
};
